const matchOperators = /[|\\{}()[\]^$+*?.]/g;

export function escapeStringRegExp(str: string) {
  return new RegExp(str.replace(matchOperators, '\\$&'));
}
